import atlasManage from './atlasManage'
import nameCard from './nameCardManage'

export default [atlasManage, nameCard]
